import { Star } from "lucide-react";

const items = ["CUSTOM APPAREL & PRINTING IN NEW JERSEY", "NO MINIMUM ORDERS", "FAST TURNAROUND", "FAMILY OWNED & OPERATED"];

export const AnnouncementBar = () => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="bg-ink text-[#f2f0ea] py-2.5 marquee" data-testid="announcement-bar">
      <div className="marquee__track">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center text-[11px] tracking-[0.22em] font-medium">
            <span className="px-6">{t}</span>
            <Star size={10} className="text-gold fill-gold" />
          </span>
        ))}
      </div>
    </div>
  );
};
